import { forwardRef } from "react";
import { Image, Upload } from "antd";
import classNames from "classnames";
import { BasketIcon, RefreshIcon } from "@/shared/icons";
import { useTheme } from "@/services/theme";
import type { ImageProps, UploadProps } from "antd";
import { AppButton } from "../AppButton";
import NoAvatar from "../../assets/NoAvatar.png";
import NoAvatarDark from "../../assets/NoAvatarDark.png";
import styles from "./styles.module.scss";

interface Props extends ImageProps {
  isEditable: boolean;
  beforeRefreshUpload?: UploadProps["beforeUpload"];
  onDeleteImageClick?: () => void;
}

export const AppImage = forwardRef<HTMLSpanElement, Props>(
  (
    {
      className,
      isEditable,
      beforeRefreshUpload = () => "",
      onDeleteImageClick = () => "",
      ...props
    },
    ref,
  ) => {
    const { theme } = useTheme();

    return (
      <span ref={ref} className={classNames(styles["img-container"], className)}>
        <Image
          className={classNames(styles.image)}
          fallback={theme === "dark" ? NoAvatarDark : NoAvatar}
          {...props}
        />
        {isEditable && (
          <div className={styles.flex}>
            <Upload openFileDialogOnClick beforeUpload={beforeRefreshUpload} showUploadList={false}>
              <AppButton
                icon={<RefreshIcon />}
                type="text"
                className={styles["image-control-button"]}
              />
            </Upload>
            <AppButton
              icon={<BasketIcon />}
              type="text"
              onClick={(e) => {
                e.stopPropagation();
                onDeleteImageClick();
              }}
              className={styles["image-control-button"]}
            />
          </div>
        )}
      </span>
    );
  },
);
